// Treatment landing page configurations.
// Each entry maps a slug (URL) -> category + treatment used by the lead form,
// plus marketing copy, hero image, SEO metadata and trust bullets.
//
// Images are generated locally (Gemini Nano Banana) and served from
// /images/treatments/<slug>.png. Generic fallback images are reused for
// treatments that don't have a dedicated photo.

const IMG = (name) => `/images/treatments/${name}.png`;

export const TREATMENTS = {
  // === Estetikk & Kosmetikk ===
  botox: {
    slug: 'botox',
    displayName: 'Botox',
    category: 'Estetikk & Kosmetikk',
    treatment: 'Botox / Rynkebehandling',
    title: 'Få tilbud på Botox fra private klinikker',
    subtitle: 'Fyll ut ett kort skjema og bli kontaktet innen 24 timer. Gratis og uforpliktende.',
    cta: 'Få Botox-tilbud',
    seoTitle: 'Botox Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på Botox fra private klinikker. Gratis og uforpliktende forespørsel. Svar innen 24 timer.',
    image: IMG('botox'),
    bullets: ['Kun klinikker med 4+ stjerner', 'Sammenlign priser fra flere klinikker', 'Svar innen 24 timer'],
  },
  fillers: {
    slug: 'fillers',
    displayName: 'Fillers',
    category: 'Estetikk & Kosmetikk',
    treatment: 'Fillers / Leppeforming',
    title: 'Få tilbud på fillers fra erfarne behandlere',
    subtitle: 'Sammenlign klinikker og finn behandlingen som passer deg. Gratis og uforpliktende.',
    cta: 'Få fillers-tilbud',
    seoTitle: 'Fillers Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på fillers fra private klinikker med erfarne behandlere. Gratis og uforpliktende. Svar innen 24 timer.',
    image: IMG('fillers'),
    bullets: ['Erfarne, sertifiserte behandlere', 'Naturlige resultater', 'Gratis konsultasjon hos klinikken'],
  },
  'lip-fillers': {
    slug: 'lip-fillers',
    displayName: 'Lip fillers',
    category: 'Estetikk & Kosmetikk',
    treatment: 'Fillers / Leppeforming',
    title: 'Få tilbud på lip fillers',
    subtitle: 'Finn klinikker som tilbyr naturlige resultater og trygg behandling. Gratis og uforpliktende.',
    cta: 'Få lip fillers-tilbud',
    seoTitle: 'Lip fillers Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på lip fillers fra private klinikker. Naturlige resultater. Gratis og uforpliktende.',
    image: IMG('lip-fillers'),
    bullets: ['Naturlige, subtile resultater', 'Trygg behandling av medisinsk personell', 'Sammenlign klinikker'],
  },
  'plastisk-kirurgi': {
    slug: 'plastisk-kirurgi',
    displayName: 'Plastisk kirurgi',
    category: 'Estetikk & Kosmetikk',
    treatment: 'Plastisk kirurgi',
    title: 'Få tilbud på plastisk kirurgi',
    subtitle: 'Sammenlign sertifiserte plastikkirurger og finn riktig klinikk for deg. Gratis og uforpliktende.',
    cta: 'Få tilbud på plastisk kirurgi',
    seoTitle: 'Plastisk kirurgi Oslo og Norge | Sertifiserte plastikkirurger',
    seoDescription: 'Få tilbud på plastisk kirurgi fra sertifiserte plastikkirurger i Norge. Trygt, profesjonelt og uforpliktende.',
    image: IMG('plastisk-kirurgi'),
    bullets: ['Sertifiserte plastikkirurger', 'Trygge, godkjente klinikker', 'Personlig behandlingsplan'],
  },
  fettsuging: {
    slug: 'fettsuging',
    displayName: 'Fettsuging',
    category: 'Estetikk & Kosmetikk',
    treatment: 'Fettsuging',
    title: 'Få tilbud på fettsuging',
    subtitle: 'Finn klinikker som tilbyr moderne, trygg fettsuging. Gratis og uforpliktende forespørsel.',
    cta: 'Få tilbud på fettsuging',
    seoTitle: 'Fettsuging Oslo og Norge | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud på fettsuging fra erfarne plastikkirurger. Sammenlign metoder og priser. Gratis og uforpliktende.',
    image: IMG('fettsuging'),
    bullets: ['Moderne, skånsomme metoder', 'Erfarne kirurger', 'Personlig konsultasjon'],
  },

  // === Hår & Hodebunn ===
  prp: {
    slug: 'prp',
    displayName: 'PRP-behandling',
    category: 'Hår & Hodebunn',
    treatment: 'PRP hårvekst',
    title: 'Få tilbud på PRP-behandling',
    subtitle: 'Finn klinikker som tilbyr PRP mot hårtap og hodebunn. Svar innen 24 timer.',
    cta: 'Få PRP-tilbud',
    seoTitle: 'PRP-behandling Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på PRP-behandling for hårtap. Klinikker med 4+ stjerner. Gratis og uforpliktende.',
    image: IMG('prp'),
    bullets: ['Mot hårtap og tynt hår', 'Medisinsk kvalifiserte klinikker', 'Naturlig behandling med eget blod'],
  },
  hartransplantasjon: {
    slug: 'hartransplantasjon',
    displayName: 'Hårtransplantasjon',
    category: 'Hår & Hodebunn',
    treatment: 'Hårtransplantasjon',
    title: 'Få tilbud på hårtransplantasjon',
    subtitle: 'Sammenlign klinikker og få hjelp til å finne riktig behandling. Gratis og uforpliktende.',
    cta: 'Få hårtransplantasjon-tilbud',
    seoTitle: 'Hårtransplantasjon Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på hårtransplantasjon fra norske klinikker. Sammenlign priser og metoder. Gratis og uforpliktende.',
    image: IMG('hartransplantasjon'),
    bullets: ['FUE og DHI-spesialister', 'Permanent resultat', 'Erfarne klinikker i Oslo'],
  },
  'laserbehandling-har': {
    slug: 'laserbehandling-har',
    displayName: 'Laserbehandling (hår)',
    category: 'Hår & Hodebunn',
    treatment: 'Laserbehandling (hår)',
    title: 'Få tilbud på laserbehandling mot hårtap',
    subtitle: 'Finn klinikker som tilbyr lavnivå-laser (LLLT) mot hårtap. Gratis og uforpliktende.',
    cta: 'Få lasertilbud',
    seoTitle: 'Laserbehandling mot hårtap | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud på laserbehandling mot hårtap fra norske klinikker. Skånsom og smertefri behandling.',
    image: IMG('laserbehandling-har'),
    bullets: ['Skånsom og smertefri behandling', 'Mot tidlig hårtap', 'Erfarne hårspesialister'],
  },

  // === Hud & Laser ===
  laserbehandling: {
    slug: 'laserbehandling',
    displayName: 'Laserbehandling (hud)',
    category: 'Hud & Laser',
    treatment: 'Laserbehandling (hud)',
    title: 'Få tilbud på laserbehandling',
    subtitle: 'Finn klinikker for hud, arr, pigment og hudforbedring. Gratis og uforpliktende.',
    cta: 'Få laser-tilbud',
    seoTitle: 'Laserbehandling Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på laserbehandling for hud, arr og pigmentflekker. Gratis og uforpliktende forespørsel.',
    image: IMG('laserbehandling'),
    bullets: ['Mot pigmentflekker, akne-arr og rosacea', 'Moderne lasersystemer', 'Erfarne hudterapeuter'],
  },
  hudforyngelse: {
    slug: 'hudforyngelse',
    displayName: 'Hudforyngelse',
    category: 'Hud & Laser',
    treatment: 'Hudforyngelse',
    title: 'Få tilbud på hudforyngelse',
    subtitle: 'Finn klinikker for behandlinger som strammer, fornyer og forbedrer huden.',
    cta: 'Få tilbud på hudforyngelse',
    seoTitle: 'Hudforyngelse Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på hudforyngelse fra erfarne hudterapeuter. Microneedling, peeling, laser og mer.',
    image: IMG('hudforyngelse'),
    bullets: ['Microneedling, peeling, laser', 'Synlig effekt etter første behandling', 'Personlig hudplan'],
  },
  aknebehandling: {
    slug: 'aknebehandling',
    displayName: 'Aknebehandling',
    category: 'Hud & Laser',
    treatment: 'Aknebehandling',
    title: 'Få tilbud på aknebehandling',
    subtitle: 'Finn klinikker som tilbyr medisinsk aknebehandling og oppfølging.',
    cta: 'Få aknetilbud',
    seoTitle: 'Aknebehandling Oslo og Norge | Få tilbud fra private klinikker',
    seoDescription: 'Få tilbud på medisinsk aknebehandling og hudpleie fra norske klinikker. Gratis og uforpliktende.',
    image: IMG('aknebehandling'),
    bullets: ['Medisinsk vurdering', 'Behandlingsplan tilpasset deg', 'Oppfølging hos hudlege/-terapeut'],
  },
  pigmentflekker: {
    slug: 'pigmentflekker',
    displayName: 'Pigmentflekker / Rosacea',
    category: 'Hud & Laser',
    treatment: 'Pigmentflekker / Rosacea',
    title: 'Få tilbud på behandling av pigmentflekker og rosacea',
    subtitle: 'Sammenlign klinikker som tilbyr IPL, laser og medisinsk hudpleie.',
    cta: 'Få tilbud på behandling',
    seoTitle: 'Pigmentflekker og rosacea | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud på behandling av pigmentflekker og rosacea med IPL eller laser. Gratis og uforpliktende.',
    image: IMG('pigmentflekker'),
    bullets: ['IPL og laserbehandling', 'Medisinsk hudpleie', 'Sertifiserte hudterapeuter'],
  },

  // === Tannhelse & Smil ===
  invisalign: {
    slug: 'invisalign',
    displayName: 'Invisalign',
    category: 'Tannhelse & Smil',
    treatment: 'Usynlig tannregulering (Invisalign)',
    title: 'Få tilbud på Invisalign',
    subtitle: 'Rette tenner diskret med hjelp fra private tannklinikker. Gratis og uforpliktende.',
    cta: 'Få Invisalign-tilbud',
    seoTitle: 'Invisalign Oslo og Norge | Få tilbud fra private tannklinikker',
    seoDescription: 'Få tilbud på Invisalign fra Invisalign-sertifiserte tannklinikker. Gratis og uforpliktende.',
    image: IMG('invisalign'),
    bullets: ['Invisalign-sertifiserte tannleger', 'Diskret og avtakbar', 'Behandlingsplan tilpasset deg'],
  },
  tannbleking: {
    slug: 'tannbleking',
    displayName: 'Tannbleking',
    category: 'Tannhelse & Smil',
    treatment: 'Tannbleking',
    title: 'Få tilbud på tannbleking',
    subtitle: 'Finn tannklinikker som tilbyr trygg og profesjonell tannbleking.',
    cta: 'Få tannbleking-tilbud',
    seoTitle: 'Tannbleking Oslo og Norge | Få tilbud fra private tannklinikker',
    seoDescription: 'Få tilbud på profesjonell tannbleking fra norske tannklinikker. Gratis og uforpliktende.',
    image: IMG('tannbleking'),
    bullets: ['Trygg og profesjonell metode', 'Klinikkbleking eller hjemmebleking', 'Synlig resultat etter første økt'],
  },
  'kosmetisk-tannlege': {
    slug: 'kosmetisk-tannlege',
    displayName: 'Kosmetisk tannlege',
    category: 'Tannhelse & Smil',
    treatment: 'Kosmetisk tannlege',
    title: 'Få tilbud fra kosmetisk tannlege',
    subtitle: 'Sammenlign tannklinikker som tilbyr fasetter, kroner, bleking og smildesign.',
    cta: 'Få tilbud',
    seoTitle: 'Kosmetisk tannlege Oslo og Norge | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud fra kosmetisk tannlege i Norge — fasetter, kroner, smildesign og bleking. Gratis og uforpliktende.',
    image: IMG('kosmetisk-tannlege'),
    bullets: ['Smildesign og estetisk tannpleie', 'Erfarne kosmetiske tannleger', 'Sammenlign priser og klinikker'],
  },
  fasetter: {
    slug: 'fasetter',
    displayName: 'Fasetter',
    category: 'Tannhelse & Smil',
    treatment: 'Fasetter',
    title: 'Få tilbud på fasetter (veneers)',
    subtitle: 'Finn tannklinikker som tilbyr porselen- eller komposittfasetter for et nytt smil.',
    cta: 'Få tilbud på fasetter',
    seoTitle: 'Fasetter (veneers) Oslo og Norge | Tilbud fra private tannklinikker',
    seoDescription: 'Få tilbud på fasetter (veneers) fra norske tannklinikker. Porselen og komposittfasetter. Gratis og uforpliktende.',
    image: IMG('fasetter'),
    bullets: ['Porselen- og komposittfasetter', 'Naturlig, hvitt smil', 'Erfarne kosmetiske tannleger'],
  },
  kjevebehandling: {
    slug: 'kjevebehandling',
    displayName: 'Kjevebehandling',
    category: 'Tannhelse & Smil',
    treatment: 'Kjevebehandling (TMD / bittskinne)',
    title: 'Få hjelp med kjeveplager',
    subtitle: 'Finn behandlere for kjeve, bitt, press, klikking og smerter. Gratis og uforpliktende.',
    cta: 'Få tilbud på kjevebehandling',
    seoTitle: 'Kjevebehandling Oslo og Norge | Få hjelp med kjeveplager',
    seoDescription: 'Finn klinikker for kjeveplager, kjeveledd, bittskinne og TMD-behandling. Gratis og uforpliktende.',
    image: IMG('kjevebehandling'),
    bullets: ['Mot kjeveledd, klikking og press', 'Spesialtilpasset bittskinne', 'Erfarne tannleger og kjevespesialister'],
  },

  // === Fysioterapi & Kiropraktor ===
  fysioterapi: {
    slug: 'fysioterapi',
    displayName: 'Fysioterapi',
    category: 'Fysioterapi & Kiropraktor',
    treatment: 'Fysioterapi (privat)',
    title: 'Få tilbud på privat fysioterapi',
    subtitle: 'Finn fysioterapeuter med korte ventetider. Gratis og uforpliktende forespørsel.',
    cta: 'Få fysio-tilbud',
    seoTitle: 'Privat fysioterapi Oslo og Norge | Korte ventetider',
    seoDescription: 'Få tilbud på privat fysioterapi fra norske klinikker. Korte ventetider og erfarne fysioterapeuter.',
    image: IMG('fysioterapi'),
    bullets: ['Autoriserte fysioterapeuter', 'Korte ventetider', 'Behandlingsplan tilpasset deg'],
  },
  kiropraktor: {
    slug: 'kiropraktor',
    displayName: 'Kiropraktor',
    category: 'Fysioterapi & Kiropraktor',
    treatment: 'Kiropraktor',
    title: 'Få tilbud på kiropraktor',
    subtitle: 'Finn autoriserte kiropraktorer i Norge. Gratis og uforpliktende.',
    cta: 'Få tilbud på kiropraktor',
    seoTitle: 'Kiropraktor Oslo og Norge | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud fra autoriserte kiropraktorer i Norge. Behandling av rygg, nakke og hode.',
    image: IMG('kiropraktor'),
    bullets: ['Autoriserte kiropraktorer', 'Korte ventetider', 'Personlig behandlingsplan'],
  },
  sportsmedisin: {
    slug: 'sportsmedisin',
    displayName: 'Sportsmedisin',
    category: 'Fysioterapi & Kiropraktor',
    treatment: 'Sportsmedisin',
    title: 'Få tilbud på sportsmedisin',
    subtitle: 'Idrettsskader, rehabilitering og prestasjonsoppfølging hos sportsmedisinske spesialister.',
    cta: 'Få sportsmedisin-tilbud',
    seoTitle: 'Sportsmedisin Oslo og Norge | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud fra sportsmedisinske spesialister i Norge. Idrettsskader, rehabilitering og treningsmedisin.',
    image: IMG('fysioterapi'),
    bullets: ['Idrettsmedisinske leger og fysioterapeuter', 'Korte ventetider', 'Skaderehabilitering'],
  },
  rehabilitering: {
    slug: 'rehabilitering',
    displayName: 'Rehabilitering',
    category: 'Fysioterapi & Kiropraktor',
    treatment: 'Rehabilitering',
    title: 'Få tilbud på rehabilitering',
    subtitle: 'Finn klinikker med moderne rehabiliteringstilbud — etter skade, operasjon eller belastning.',
    cta: 'Få rehab-tilbud',
    seoTitle: 'Rehabilitering Oslo og Norge | Privat rehabilitering uten ventetid',
    seoDescription: 'Få tilbud på privat rehabilitering etter skade, operasjon eller belastning. Erfarne fysioterapeuter og leger.',
    image: IMG('fysioterapi'),
    bullets: ['Tverrfaglige team', 'Personlig rehab-plan', 'Korte ventetider'],
  },
  massasjeterapeut: {
    slug: 'massasjeterapeut',
    displayName: 'Massasjeterapeut',
    category: 'Fysioterapi & Kiropraktor',
    treatment: 'Massasjeterapeut',
    title: 'Få tilbud fra massasjeterapeut',
    subtitle: 'Finn autoriserte massasjeterapeuter for muskelplager, stivhet og avspenning.',
    cta: 'Få tilbud',
    seoTitle: 'Massasjeterapeut Oslo og Norge | Privat massasjeterapi',
    seoDescription: 'Få tilbud fra autorisert massasjeterapeut. Klassisk, sportsmassasje og triggerpunkt-behandling.',
    image: IMG('fysioterapi'),
    bullets: ['Autoriserte massasjeterapeuter', 'Mot muskelplager og stivhet', 'Avspennende eller terapeutisk'],
  },

  // === Øye & Syn ===
  oyenlaser: {
    slug: 'oyenlaser',
    displayName: 'Øyenlaser (LASIK/LASEK)',
    category: 'Øye & Syn',
    treatment: 'Øyenlaser (LASIK/LASEK)',
    title: 'Få tilbud på øyenlaser',
    subtitle: 'Sammenlign LASIK og LASEK-klinikker i Norge. Gratis og uforpliktende.',
    cta: 'Få tilbud på øyenlaser',
    seoTitle: 'Øyenlaser (LASIK/LASEK) Oslo og Norge | Tilbud fra private klinikker',
    seoDescription: 'Få tilbud på øyenlaser (LASIK/LASEK) fra erfarne øyeklinikker i Norge. Gratis og uforpliktende.',
    image: IMG('oyenlaser'),
    bullets: ['Erfarne øyekirurger', 'LASIK og LASEK-metoder', 'Gratis konsultasjon hos klinikken'],
  },

  // === Øre-Nese-Hals ===
  'onh-spesialist': {
    slug: 'onh-spesialist',
    displayName: 'ØNH-spesialist',
    category: 'Øre-Nese-Hals',
    treatment: 'ØNH-spesialist (privat)',
    title: 'Få time hos privat ØNH-spesialist',
    subtitle: 'Finn øre-nese-hals-spesialister med korte ventetider. Gratis og uforpliktende.',
    cta: 'Få ØNH-tilbud',
    seoTitle: 'Privat ØNH-spesialist Oslo og Norge | Korte ventetider',
    seoDescription: 'Få time hos privat ØNH-spesialist uten lang ventetid. Sammenlign klinikker. Gratis og uforpliktende.',
    image: IMG('onh-spesialist'),
    bullets: ['Autoriserte ØNH-leger', 'Korte ventetider', 'Tilbud i Oslo, Bærum og flere byer'],
  },
};

export const treatmentBySlug = (slug) => TREATMENTS[slug];
